import React, {Component} from 'react'
import {observable} from 'mobx'
import {observer} from 'mobx-react'

import SpanButton, {Colors} from 'lib/control/SpanButton'

import Field from '../../struct/Field'
import Checkbox from '../../control/DependentCheckbox'
import SearchableSelect from '../../control/DependentSearchableSelect'
import SettingsGroup from '../../struct/SettingsGroup'
import YandexCategoryMappingTable from './YandexCategoryMappingTable'

import styles from './ProfileCategorySettings.less'
import * as SelectionMode from "../../../constant/ProfileCatalogSelectionMode";
import Select from "../../control/DependentSelect";
import NestedField from "../../struct/NestedField";
import TagSourceField from "../../struct/TagSourceField";

const EMPTY_YANDEX_CATEGORY_OPTION = {
    label: '',
    value: '',
}

const COLLECTION_NAME_OPTIONS = [{
    label: 'Название',
    value: 'category_name'
} , {
    label: 'SEO-название (плагин "SEO-оптимизация")',
    value: 'category_seo_name'
}, {
    label: 'Заголовок H1  (плагин SEO-оптимизация)',
    value: 'category_h1'
}]

@observer export default class ProfileCategorySettings extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selected_category_ids: observable(new Map()),
            selected_yandex_category_option: EMPTY_YANDEX_CATEGORY_OPTION,
            is_new_categories_loaded: window.is_new_categories_loaded,
        }
    }

    render() {
        const {title} = this.props
        const {selected_yandex_category_option, is_new_categories_loaded} = this.state
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        return (
            <SettingsGroup
                title={title}
            >
                <Field label="Каталоги">
                    <Checkbox
                        checked={profile.catalog_selection_export_collections}
                        onChange={e => profile.catalog_selection_export_collections = e.target.checked}
                        state={context.form_state}
                    >
                        Выгружать каталоги
                    </Checkbox>
                </Field>
                { profile.catalog_selection_export_collections ? (
                    <TagSourceField
                        label="Название категории"
                        tag="collection><name"
                        flexible_content
                    >
                        <Select
                            options={COLLECTION_NAME_OPTIONS}
                            value={profile.collection_name}
                            onChange={e => profile.collection_name = e.target.value}
                            state={context.form_state}
                        />
                    </TagSourceField>
                ) : (null)
                }

                <Field label="Скрытые категории">
                    <Checkbox
                        checked={profile.catalog_selection_export_hidden_categories}
                        onChange={e => profile.catalog_selection_export_hidden_categories = e.target.checked}
                        state={context.form_state}
                    >
                        Выгружать скрытые категории
                    </Checkbox>
                </Field>

                <Field label="Категории">
                    <Checkbox
                        checked={profile.category_is_yandex_category_mapping_enabled}
                        onChange={e => profile.category_is_yandex_category_mapping_enabled = e.target.checked}
                        state={context.form_state}
                    >
                        Сопоставить категории с каталогом Яндекс.Маркет
                    </Checkbox>
                </Field>

                {
                    profile.category_is_yandex_category_mapping_enabled ? (
                        <Field>
                            {this.state.is_new_categories_loaded !== 1 && <div>
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        $.get(backend_url + 'shop/?plugin=market&module=repair&action=newRefillYandexCategoriesTable')
                                        this.setState({
                                            ...this.state,
                                            is_new_categories_loaded: 1
                                        })
                                    }
                                    }
                                    href={'#'}>Обновить
                                    категории Маркета</a>
                            </div>}

                            <div className={styles['mapping-block']}>
                                <div className={styles['mapping-table-block']}>
                                    <YandexCategoryMappingTable
                                        context={context}
                                        isCategoryIdSelected={this.isCategoryIdSelected}
                                        toggleCategoryIdSelection={this.toggleCategoryIdSelection}
                                    />
                                </div>

                                <div className={styles['yandex-category-block']}>
                                    <div className={styles['yandex-category-label']}>
                                        Задать выбранным категориям:
                                    </div>
                                    <SearchableSelect
                                        loadOptions={search => context.fetchYandexCategoryOptions(search)}
                                        noOptionsMessage={({inputValue: search}) => search.length < 3 ? 'Печатайте для поиска' : 'Ничего не найдено'}
                                        loadingMessage={() => 'Загрузка...'}
                                        value={selected_yandex_category_option}
                                        onChange={this.onYandexCategorySelectChange}
                                        className={styles['yandex-category-select']}
                                        state={context.form_state}
                                    />
                                    <SpanButton
                                        onClick={this.applySelectedCategoriesMapping}
                                        color={Colors.GREEN}
                                        className={styles['yandex-category-apply-button']}
                                    >
                                        Применить
                                    </SpanButton>
                                </div>
                            </div>
                        </Field>
                    ) : (null)
                }
            </SettingsGroup>
        )
    }

    isCategoryIdSelected = category_id => {
        return this.state.selected_category_ids.has(category_id)
    }

    toggleCategoryIdSelection = category_id => {
        if (this.state.selected_category_ids.has(category_id)) {
            this.state.selected_category_ids.delete(category_id)
        } else {
            this.state.selected_category_ids.set(category_id, true)
        }
    }

    onYandexCategorySelectChange = option => {
        this.setState({
            selected_yandex_category_option: option,
        })
    }

    applySelectedCategoriesMapping = () => {
        const {selected_category_ids, selected_yandex_category_option} = this.state
        const selected_yandex_category = selected_yandex_category_option.value
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        for (const category_id of selected_category_ids.keys()) {
            if (selected_yandex_category === '') {
                context.profile.category_yandex_category_mapping.delete(category_id)
            } else {
                context.profile.category_yandex_category_mapping.set(category_id, parseInt(selected_yandex_category))
            }
        }

        selected_category_ids.clear()

        this.setState({
            selected_yandex_category: EMPTY_YANDEX_CATEGORY_OPTION,
        })
    }
}
